import { Goto } from "@/shared/navigation";

import { RobotoLinkHoverUnderline } from "../RobotoLinkHoverUnderline";

interface TriggerNameLinkProps {
  triggerName: string;
  /** Extra class(es) for call-site typography, e.g. a table's cell style. */
  className?: string;
}

/**
 * A link to a trigger's page, labeled with and addressed by the trigger's
 * org-unique name. Use it when the name comes from a fetched trigger record,
 * so the link reaches a trigger that exists; {@link TriggerLink} takes a
 * trigger id and fetches the record first.
 */
export function TriggerNameLink({
  triggerName,
  className,
}: TriggerNameLinkProps) {
  return (
    <RobotoLinkHoverUnderline
      to={Goto.createTriggerRoute(triggerName)}
      className={className}
    >
      {triggerName}
    </RobotoLinkHoverUnderline>
  );
}
